import { useState } from "react";

import DownloadIcon from "@src/assets/icons/download.svg";
import { App, Button, Spin, Tooltip } from "antd";

interface IDownloadButton {
  path: string;
  disabled?: boolean;
  method?: string;
  completeData?: any;
  filteredData?: any;
}

const DownloadButton = ({
  path,
  disabled,
  method = "get",
  completeData,
  filteredData,
}: IDownloadButton) => {
  const { modal } = App.useApp();

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const serverUrl =
    import.meta.env.MODE === "development"
      ? import.meta.env.VITE_SERVER_URL + "api"
      : window.location.protocol + "//" + window.location.host + "/api";

  function downloadData(dataToDownload) {
    const token = localStorage.getItem("token");
    let fileName;
    setIsLoading(true);

    fetch(`${serverUrl}${path}`, {
      method: method || "get",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(dataToDownload),
    })
      .then((res) => {
        fileName = res.headers.get("Content-Disposition");
        return res.blob();
      })
      .then((blob) => {
        const href = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = href;
        link.setAttribute("download", fileName); //or any other extension
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch((err) => {
        return Promise.reject(new Error(`Something went wrong: ${err}`));
      })
      .finally(() => {
        setIsLoading(false);
      });
  }

  const confirmDownload = () => {
    modal.confirm({
      autoFocusButton: null,
      content: "All the data will be downloaded. Do you want to continue?",
      onOk() {
        downloadData(completeData);
      },
    });
  };

  const exportFilteredData = () => {
    if (
      filteredData?.length > 0 &&
      filteredData?.length !== completeData?.length
    ) {
      modal.confirm({
        autoFocusButton: null,
        content: "Would you like to download the filtered data?",
        okText: "Yes",
        cancelText: "No",
        onOk() {
          downloadData(filteredData);
        },
        onCancel() {
          confirmDownload();
        },
      });
    } else {
      downloadData(completeData);
    }
  };

  return (
    <>
      <Spin spinning={isLoading} fullscreen />
      <Tooltip
        mouseEnterDelay={0.5}
        placement="top"
        title={"Download as .xlsx"}
      >
        <Button
          color="default"
          variant="filled"
          htmlType="submit"
          icon={<DownloadIcon />}
          disabled={disabled}
          onClick={exportFilteredData}
          size="large"
          data-testid="download-button"
        />
      </Tooltip>
    </>
  );
};

export default DownloadButton;
